// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__Manrope_5e3697', '__Manrope_Fallback_5e3697', --font-family-sans","fontStyle":"normal"},"className":"__className_5e3697","variable":"__variable_5e3697"};